<template>
  <div>
    <v-select
      v-model="selectedLobby"
      :items="items"
      @change="setSelectCasinoLobby"
      item-text="text"
      item-value="value"
      :label="$t('filterByLobby')"
      :menu-props="{ bottom: true, offsetY: true }"
      prepend-icon="mdi-slot-machine-outline"
      dense
      hide-details
      solo-inverted
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "select-casino-type",
  data: (self) => ({
    selectedLobby: { text: self.$t('lobbyCasino'), value: 0 },
  }),

  computed: {
    lobbyState() {
      return this.$store.state.filters.selectCasinoLobby.value
    },

    items() {
      const itemsLobbyType = [
        {
          text: this.$t('lobbyCasino'),
          value: 0,
        },
        {
          text: this.$t('lobbyCasinoLive'),
          value: 1,
        },
      ]

      if (
        this.$route.name === 'ListCategories' ||
        this.$route.name === 'CollaboratorListCategories' ||
        this.$route.name === 'CasinoListBetOnline' ||
        this.$route.name === "CollaboratorCasinoListBetOnline"
      ) {
        itemsLobbyType.unshift({ text: this.$t('lobbyAll'), value: "" });
        return itemsLobbyType;
      }
      return itemsLobbyType;
    },
  },

  watch: {
    $route() {
      if (
        this.$route.name === "ListGames" ||
        this.$route.name === "CollaboratorListGames"
      ) {
        this.selectedLobby = { text: this.$t('lobbyCasino'), value: 0 }
        this.$store.commit("setSelectCasinoLobby", 0);
      } else {
        this.selectedLobby = { text: this.$t('lobbyAll'), value: "" }
        this.$store.commit("setSelectCasinoLobby", "");
      }
    }
  },

  methods: {
    setSelectCasinoLobby(value) {
      this.$store.commit("setSelectCasinoLobby", value);
    },
  },
};
</script>